export default {
    path: '/', component: () => import("@/pages/Cabinet/Admin/App"),
    children: [
        {
            path: '/cabinet', name: 'admin.cabinet', redirect: {name: 'admin.cabinet.calendar'},
        },
        {
            path: '/cabinet/admin/calendar',
            name: 'admin.cabinet.calendar',
            component: () => import("@/pages/Cabinet/Admin/AdministratorCalendar"),
        },
        {
            path: '/cabinet/admin/masters',
            name: 'admin.cabinet.masters',
            component: () => import("@/pages/Cabinet/Admin/Master/Index"),
        },
        {
            path: '/cabinet/admin/statistics',
            name: 'admin.cabinet.analytics',
            component: () => import("@/pages/Cabinet/Admin/Analytics/Index"),
        },
        {
            path: '/cabinet/admin/messages',
            name: 'admin.cabinet.chat',
            component: () => import("@/pages/Cabinet/Admin/Chat"),
        },
        {
            path: '/cabinet/admin/client',
            name: 'admin.cabinet.client',
            component: () => import("@/pages/Cabinet/Admin/Client/Index"),
        },
        {
            path: '/cabinet/admin/offlinePurchase',
            name: 'admin.cabinet.offlinePurchase',
            component: () => import("@/pages/Cabinet/Admin/offlinePurchase"),
        },
    ]
};
